// Dynamic File Size Configuration
// Update these values when you upload new versions of your files

export const FILE_SIZES = {
  // Google Drive File IDs and their current sizes
  googleDriveFiles: {
    '1bma-pqUCJjrwVBWBx5IvBglFors7USvs': {
      name: 'Windows Installer',
      size: 19456000, // Size in bytes
      lastUpdated: '2025-09-06'
    },
    '1C-F3DTwVoebNM8fuBqcGJyWdDmZH-1eP': {
      name: 'Android APK',
      size: 108593152, // Size in bytes
      lastUpdated: '2025-09-06'
    }
  },

  // Platform fallback sizes (automatically calculated)
  platformFallbacks: {
    windows: '18.6 MB',
    android: '103.6 MB',
    macos: 'Unknown'
  }
};

// Helper function to format bytes to human readable format
export const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return 'Unknown';
  
  const kb = bytes / 1024;
  const mb = bytes / (1024 * 1024);
  const gb = bytes / (1024 * 1024 * 1024);
  
  if (gb >= 1) {
    return `${gb.toFixed(1)} GB`;
  } else if (mb >= 1) {
    return `${mb.toFixed(1)} MB`;
  } else {
    return `${Math.round(kb)} KB`;
  }
};

// Get file size by Google Drive file ID
export const getFileSizeById = (fileId) => {
  const fileInfo = FILE_SIZES.googleDriveFiles[fileId];
  return fileInfo ? formatFileSize(fileInfo.size) : null;
};

// Update file size (for future use when files change)
export const updateFileSize = (fileId, newSize) => {
  if (FILE_SIZES.googleDriveFiles[fileId]) {
    FILE_SIZES.googleDriveFiles[fileId].size = newSize;
    FILE_SIZES.googleDriveFiles[fileId].lastUpdated = new Date().toISOString().split('T')[0];
  }
};

// Instructions for updating file sizes:
// 1. When you upload a new version of your file to Google Drive
// 2. Update the size in bytes in the googleDriveFiles object above
// 3. Update the lastUpdated date
// 4. The website will automatically show the new file size
